export default __webpack_public_path__ + "static/media/book.32590b69.svg";